import { Manager } from '@entities/clients';
import { gql, useQuery } from 'urql';

const GET_SMINEX_CLUB_MANAGERS_QUERY = gql`
  query GetSminexClubManagers {
    getSminexClubManagers {
      id
      participantId
      firstName
      lastName
      surname
      active
    }
  }
`;

export interface SminexClubManagersResponse {
  getSminexClubManagers: Manager[];
}

export const useFetchSminexClubManagers = () => {
  const [{ data, fetching, error }] = useQuery<SminexClubManagersResponse>({ query: GET_SMINEX_CLUB_MANAGERS_QUERY });

  const managers = data?.getSminexClubManagers;

  return { fetching, error, managers };
};
